// PersistentFlame.jsx
import { useState, useEffect, useRef } from 'react';
import { handleShare } from '../MarketingUtils/Share';

export default function PersistentFlame() {
  const [open, setOpen] = useState(false);
  const shownRef = useRef(false);

  useEffect(() => {
    const handleScroll = () => {
      if (shownRef.current) return;
      const scrollTop = window.scrollY || window.pageYOffset;
      const docHeight = document.documentElement.scrollHeight - window.innerHeight;
      const scrolled = docHeight > 0 ? scrollTop / docHeight : 0;
      if (scrolled >= 0.9) {
        setOpen(true);
        shownRef.current = true;
        window.removeEventListener('scroll', handleScroll);
      }
    };
    window.addEventListener('scroll', handleScroll);
    // Save reference to handler for removal on close
    shownRef.current = false;
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Remove scroll event when closed
  useEffect(() => {
    if (!open) {
      window.removeEventListener('scroll', () => {}); // Defensive, but not enough
    }
  }, [open]);

  const handleClose = () => {
    setOpen(false);
    shownRef.current = true;
    // Remove scroll event listener so popup can't be triggered again
    window.removeEventListener('scroll', handleScrollGlobal);
  };

  // To ensure we can remove the scroll handler, define it globally
  const handleScrollGlobal = () => {};

  if (!open) return null;
  return (
    <div className="fixed bottom-4 right-4 bg-gradient-to-r from-indigo-800 to-indigo-900 z-10 text-white p-4 rounded-xl shadow-xl text-sm max-w-xs">
      <button
        className="absolute top-2 right-3 text-indigo-200 hover:text-white text-2xl font-bold focus:outline-none"
        aria-label="Close"
        onClick={handleClose}
        style={{ lineHeight: 1 }}
      >
        &times;
      </button>
      <h3 className="font-bold text-xl text-indigo-50 mb-3">Keep the Flame Alive</h3>
      <p className="opacity-90 mb-2">
        Your support keeps Andlegur growing. Share now and walk others into healing and alignment.
      </p>
      <button
        className="bg-rose-500 hover:bg-indigo-600 text-indigo-50 px-3 py-1 rounded-lg transition"
        onClick={handleShare}
      >
        Share
      </button>
    </div>
  );
}
